import MapRoot from './Root';
import MapLoader from './Loader';

const Map = {
  Root: MapRoot,
  Loader: MapLoader,
};

export default Map;
